function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from '@tanstack/react-router';
import { Button, Label, SearchableSelect, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Slider, Switch } from '@ui/primitives';
import { application_node_dependencies_path, useTypedParams } from '@ui/routes';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
export const defaultNodeGraphFilterData = {
    selectedNode: undefined,
    nodeDepth: 1,
    direction: false,
    linesThickness: 1
};
export function NodeGraphFilter(param) {
    let { nodes, filter = defaultNodeGraphFilterData, onChange } = param;
    const navigate = useNavigate();
    const { organization, project, application } = useTypedParams();
    const [firstInit, setFirstInit] = useState(true);
    const { watch, control, reset, getValues } = useForm({
        defaultValues: _object_spread({}, filter)
    });
    useEffect(()=>{
        if (firstInit) {
            setFirstInit(false);
            return;
        }
        reset(filter);
    }, [
        filter,
        firstInit,
        reset
    ]);
    useEffect(()=>{
        const { unsubscribe } = watch((value)=>{
            onChange(value);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        onChange,
        watch
    ]);
    const goToNode = ()=>{
        const selectedNode = getValues('selectedNode');
        if (!selectedNode) {
            return;
        }
        const url = application_node_dependencies_path({
            applicationId: selectedNode.applicationId,
            organization: {
                name: organization
            },
            project: {
                name: project
            },
            application: {
                name: application
            }
        });
        void navigate({
            to: url
        });
    };
    const clearFilter = ()=>{
        reset(_object_spread({}, defaultNodeGraphFilterData));
    };
    // Convert nodes to SearchableSelect options
    const nodeOptions = nodes.map((node)=>({
            value: node.id,
            label: node.fullName
        }));
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-5 bg-secondary rounded-xl h-full flex flex-col justify-between gap-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Label, {
                                htmlFor: "choose-node",
                                className: "font-semibold text-sm",
                                children: "Choose node"
                            }),
                            /*#__PURE__*/ _jsx(Controller, {
                                name: "selectedNode",
                                control: control,
                                render: (param)=>{
                                    let { field: { onChange: onFieldChange, value } } = param;
                                    return /*#__PURE__*/ _jsx(SearchableSelect, {
                                        options: nodeOptions,
                                        value: (value === null || value === void 0 ? void 0 : value.id) || '',
                                        onChange: (selectedValue)=>{
                                            const node = nodes.find((n)=>n.id === selectedValue);
                                            onFieldChange(node);
                                        },
                                        placeholder: "Select a node",
                                        className: "w-full"
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Label, {
                                htmlFor: "node-depth",
                                className: "font-semibold text-sm",
                                children: "Node depth"
                            }),
                            /*#__PURE__*/ _jsx(Controller, {
                                name: "nodeDepth",
                                control: control,
                                render: (param)=>{
                                    let { field: { onChange: onFieldChange, value } } = param;
                                    return /*#__PURE__*/ _jsxs(Select, {
                                        value: value === null || value === void 0 ? void 0 : value.toString(),
                                        onValueChange: (val)=>onFieldChange(Number(val)),
                                        children: [
                                            /*#__PURE__*/ _jsx(SelectTrigger, {
                                                id: "node-depth",
                                                className: "w-full",
                                                children: /*#__PURE__*/ _jsx(SelectValue, {})
                                            }),
                                            /*#__PURE__*/ _jsxs(SelectContent, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(SelectItem, {
                                                        value: "1",
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ _jsx(SelectItem, {
                                                        value: "2",
                                                        children: "2"
                                                    }),
                                                    /*#__PURE__*/ _jsx(SelectItem, {
                                                        value: "3",
                                                        children: "3"
                                                    }),
                                                    /*#__PURE__*/ _jsx(SelectItem, {
                                                        value: "4",
                                                        children: "4"
                                                    }),
                                                    /*#__PURE__*/ _jsx(SelectItem, {
                                                        value: "5",
                                                        children: "5"
                                                    }),
                                                    /*#__PURE__*/ _jsx(SelectItem, {
                                                        value: "0",
                                                        children: "All"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col gap-2 border-t pt-4",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx(Label, {
                                    htmlFor: "direction-switch",
                                    className: "font-bold text-sm text-secondary-foreground",
                                    children: "Direction of Connections"
                                }),
                                /*#__PURE__*/ _jsx(Controller, {
                                    name: "direction",
                                    control: control,
                                    render: (param)=>{
                                        let { field: { onChange: onFieldChange, value, ref } } = param;
                                        return /*#__PURE__*/ _jsx(Switch, {
                                            id: "direction-switch",
                                            checked: value,
                                            onCheckedChange: onFieldChange,
                                            ref: ref
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-2 border-t pt-4",
                        children: [
                            /*#__PURE__*/ _jsx(Label, {
                                htmlFor: "thickness-slider",
                                className: "font-bold text-sm text-secondary-foreground",
                                children: "Thickness of Lines"
                            }),
                            /*#__PURE__*/ _jsx(Controller, {
                                name: "linesThickness",
                                control: control,
                                render: (param)=>{
                                    let { field: { onChange: onFieldChange, value } } = param;
                                    return /*#__PURE__*/ _jsx(Slider, {
                                        id: "thickness-slider",
                                        value: [
                                            value || 1
                                        ],
                                        onValueChange: (vals)=>onFieldChange(vals[0]),
                                        step: 0.5,
                                        min: 1,
                                        max: 5,
                                        className: "w-full"
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "default",
                        size: "lg",
                        disabled: !filter.selectedNode,
                        onClick: goToNode,
                        className: "w-full",
                        children: "Go inside of Node"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "secondary",
                        size: "lg",
                        onClick: clearFilter,
                        className: "w-full",
                        children: "Clear Filters"
                    })
                ]
            })
        ]
    });
}
